import InputTypesEnum from '../../../Enums/InputTypesEnum';
import FreelancerFeeService from '../../../Services/FreelancerFeeService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. FeePanels always passes the selected fee (crudType=Update),
// so this is never invoked, but it keeps the windowDescription contract satisfied.
class CloseFeeEditItem {}

// Mirrors the old CloseFeePanel's cross-field check (both Start and End share this validator).
// GeneralEditWizzardPage's per-field InputWithClear calls this as (value, editedItem), so the
// full item is available; the wizard's "entire form" enablement check only passes the single
// field value (editedItem undefined there), matching the existing pattern used by
// ValidityHelper.forDifferentFieldworkAndHiringOffice / forFteEndDateWithinStartMonth.
const validityCheckerForStartAndEndDate = (value, editedItem) => {
  if (!editedItem) return '';
  return new Date(editedItem.StartDate) > new Date(editedItem.EndDate)
    ? 'The End Date has to be later than the Start Date.'
    : '';
};

export default class CloseFeeWindowDescription {
  static titleForEdit = (item) => `${item.FreelancerUserName} - Close Vendor Fee (${item.FreelancerFeeId})`;
  static itemType = CloseFeeEditItem;
  static finishButtonLabel = 'Close Fee';
  static messageOnSuccess = 'Fee has been closed.';

  // Mirrors the old panel's clickOnSubmitButton: the whole edited fee object is posted back.
  // The -100 sentinel (another fee with an overlapping date range) is mapped to a wizard error
  // so the panel stays open, exactly like the old ErrorMessage.SetErrorMessage path. MUST return
  // the promise (wizard contract).
  static serviceFunction = (edited) =>
    FreelancerFeeService.CloseFreelancerFee({ ...edited }).then((result) =>
      Array.isArray(result) && result.length === 1 && result[0] === -100
        ? { error: 'Error! There is another fee with an overlapping date range.' }
        : result
    );

  static pagesInGeneralEditWizzard = [
    {
      label: 'Close Vendor Fee',
      fields: [
        {
          fieldName: 'StartDate',
          label: 'Start',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: validityCheckerForStartAndEndDate,
          disabled: true,
        },
        {
          fieldName: 'EndDate',
          label: 'End',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: validityCheckerForStartAndEndDate,
        },
      ],
    },
  ];
}
